module.exports = "https://s81616.cdn.ngenix.net/home-frontend/_next/static/images/img-9a7c03d3c553b2745887f6693fba7daa.png";